import { useEffect } from "react";

const GA_ID = process.env.REACT_APP_GA_ID;

/**
 * Loads Google Analytics 4 (G-XXXX) or Google Tag Manager (GTM-XXXX).
 * No-op if REACT_APP_GA_ID is empty or invalid.
 */
export default function GoogleAnalytics() {
  useEffect(() => {
    if (!GA_ID) return;
    if (document.getElementById("ga-tag")) return;

    const isGtm = GA_ID.startsWith("GTM-");
    const isGa4 = GA_ID.startsWith("G-");
    if (!isGtm && !isGa4) return;

    if (isGa4) {
      const s1 = document.createElement("script");
      s1.id = "ga-tag";
      s1.async = true;
      s1.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
      document.head.appendChild(s1);

      const s2 = document.createElement("script");
      s2.text = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', '${GA_ID}', { anonymize_ip: true });
      `;
      document.head.appendChild(s2);
    } else {
      // Google Tag Manager
      const s = document.createElement("script");
      s.id = "ga-tag";
      s.text = `
        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','${GA_ID}');
      `;
      document.head.appendChild(s);

      // noscript fallback
      const ns = document.createElement("noscript");
      const iframe = document.createElement("iframe");
      iframe.src = `https://www.googletagmanager.com/ns.html?id=${GA_ID}`;
      iframe.height = "0";
      iframe.width = "0";
      iframe.style.display = "none";
      iframe.style.visibility = "hidden";
      ns.appendChild(iframe);
      document.body.insertBefore(ns, document.body.firstChild);
    }
  }, []);

  return null;
}
